import { useLenis } from "lenis/react";
import { Linkedin } from "lucide-react";

const Footer = () => {
  const lenis = useLenis();
  const go = (href) => lenis?.scrollTo(href, { offset: -72, duration: 1.4 });

  return (
    <footer data-testid="site-footer" className="bg-ink text-paper px-6 md:px-12 pt-20 md:pt-28 pb-10">
      <div className="mx-auto max-w-[100rem]">
        <button data-testid="footer-logo" onClick={() => go("#top")} className="text-left">
          <span className="font-serif text-[13vw] md:text-[8vw] font-light tracking-tighter leading-none block">
            Makkar
          </span>
          <span className="block mt-2 text-xs md:text-sm uppercase tracking-[0.4em] text-taupe">
            Growth Partners
          </span>
        </button>

        <div className="mt-16 md:mt-24 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 md:gap-10 border-t border-paper/20 pt-10">
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-paper/50 mb-4">Contact</p>
            <div className="flex flex-col gap-3 items-start">
              <a
                data-testid="footer-email-link"
                href="mailto:aspenmakkarcmo@gmail.com"
                className="text-sm font-light break-all hover:text-taupe transition-colors duration-300"
              >
                aspenmakkarcmo@gmail.com
              </a>
              <a
                data-testid="footer-linkedin-link"
                href="https://www.linkedin.com/in/aspenmakkar"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-light hover:text-taupe transition-colors duration-300"
              >
                <Linkedin size={14} /> LinkedIn
              </a>
            </div>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-paper/50 mb-4">Explore</p>
            <div className="flex flex-col gap-2">
              {[["Services", "#services"], ["Process", "#process"], ["Work", "#work"], ["Journal", "#insights"]].map(([label, href]) => (
                <button
                  key={href}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  onClick={() => go(href)}
                  className="text-left text-sm font-light hover:text-taupe transition-colors duration-300"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-paper/50 mb-4">Practice</p>
            <p className="text-sm font-light text-paper/70 leading-relaxed">
              Fractional CMO services for CPG, fintech, and B2B SaaS companies.
            </p>
          </div>
          <div className="flex md:justify-end items-start">
            <button
              data-testid="footer-book-call-btn"
              onClick={() => go("#book")}
              className="inline-flex items-center gap-2 border border-paper/30 text-xs uppercase tracking-[0.2em] px-6 py-4 hover:bg-paper hover:text-ink transition-colors duration-300"
            >
              Book a Call
            </button>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row md:items-center justify-between gap-4 border-t border-paper/20 pt-8">
          <p className="text-[10px] uppercase tracking-[0.25em] text-paper/40">
            © 2026 Makkar Growth Partners. All rights reserved.
          </p>
          <p className="font-serif italic text-sm text-paper/40">
            Fractional CMO expertise. Full-time growth results.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
